import React, { useMemo } from 'react';
import { Box, Paper, Tab, Tabs, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import Forms from './Forms';
import CompanySettings from '../components/CompanySettings';
import RAMSConfig from '../components/RAMSConfig';
import SavedItems from './SavedItems';
import Vendors from './Vendors';
import Organisations from './Organisations';
import Workers from './Workers';

const getTabConfigForRole = (role) => {
  const allTabs = [
    { key: 'company-settings', label: 'Company Settings', roles: ['Office'], component: <CompanySettings /> },
    { key: 'forms', label: 'Form Templates', roles: ['Office'], component: <Forms /> },
    { key: 'rams-config', label: 'RAMS Config', roles: ['Office'], component: <RAMSConfig /> },
    { key: 'saved-items', label: 'Saved Items', roles: ['Office'], component: <SavedItems /> },
    { key: 'vendors', label: 'Vendors', roles: ['Office', 'Site Manager'], component: <Vendors /> },
    { key: 'organisations', label: 'Organisations', roles: ['Office'], component: <Organisations /> },
    { key: 'users', label: 'Users', roles: ['Office'], component: <Workers /> },
  ];

  return allTabs.filter((tab) => tab.roles.includes(role));
};

function Workspace({ currentUser }) {
  const [searchParams, setSearchParams] = useSearchParams();

  const tabs = useMemo(() => getTabConfigForRole(currentUser?.role), [currentUser?.role]);
  const requestedTab = searchParams.get('tab');
  const activeTab = tabs.some((tab) => tab.key === requestedTab) ? requestedTab : (tabs[0]?.key || '');

  const handleTabChange = (_, value) => {
    setSearchParams({ tab: value });
  };

  const activeTabConfig = tabs.find((tab) => tab.key === activeTab);

  return (
    <Box>
      <Paper sx={{ mb: 2 }}>
        <Box sx={{ px: 2, pt: 2 }}>
          <Typography variant="h5" fontWeight={600}>
            Workspace
          </Typography>
        </Box>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ px: 1 }}
        >
          {tabs.map((tab) => (
            <Tab key={tab.key} value={tab.key} label={tab.label} />
          ))}
        </Tabs>
      </Paper>

      {activeTabConfig ? (
        activeTabConfig.component
      ) : (
        <Paper sx={{ p: 3 }}>
          <Typography color="text.secondary">No workspace tabs available for your role.</Typography>
        </Paper>
      )}
    </Box>
  );
}

export default Workspace;